import { InitialPanelMemberListView } from "./components/InitialPanelMemberListView";
import type { PanelMemberListMode } from "./components/types";

interface PanelMemberListProps {
	disclaimerEnabled?: boolean;
	evalId: number;
	mode?: PanelMemberListMode;
	rfxId: number;
}

/**
 * Renders the panel-member table for either the initial-scoring or
 * final-scoring view. Row/status/action presentation lives in ./components
 * and the shared components/PanelMembers/ module.
 */
export const PanelMemberList: React.FC<PanelMemberListProps> = ({
	rfxId,
	evalId,
	mode = "initial",
	disclaimerEnabled = false,
}) => {
	return <InitialPanelMemberListView rfxId={rfxId} evalId={evalId} mode={mode} disclaimerEnabled={disclaimerEnabled} />;
};
